<template>
<div class="copy-popup-background">
    <div class="copy-popup">
        <div class="copy-popup__body">
            <h1>Kopiuj zlecenie</h1>
            <div class="form-group" :class="{ 'input-error': $v.name.$error }">
                <label>nazwa nowego zlecenia</label>
                <input class="form-control form-control-lg" type="text" v-model="name"/>
                <labelInfo v-if="!$v.name.required" type="error" message="To pole jest wymagane"/>
            </div>
            <p v-if="copied">Zlecenie zostało skopiowane. Za chwilę zostaniesz przeniesiony do edycji szczegółów zlecenia.</p>
            <div class="copy-popup__footer">
                <button class="button-normal button-normal--media" @click="copyOrder()">KOPIUJ</button>
                <button class="button-normal button-normal--cancel" @click="$emit('canceled')">ANULUJ</button>
            </div>
        </div>
      </div>
</div>
</template>

<script>

import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'
import labelInfo from '@/components/blocks/labelInfo.vue';

export default {

    name: 'copyPopup',
    components:{

        labelInfo

    },
    props:{

        orderId:{
            type: Number,
            default: 0
        },

        orderNumber:{
            type: Number,
            default: 0
        },

        orderName:{
            type: String,
            default: '',
        },

    },
    mixins: [validationMixin],
    data(){

        return{

            copied: false,
            name: '',

        }

    },
    validations: {

        name: {
            required,
        },

    },
    methods:{

        copyOrder(){

            this.$v.$touch();

            if (!this.$v.$invalid) {

               const token = localStorage.getItem('auth_token');

                let name={
                    name: this.name
                }

                this.$http.post(`orders/${this.orderId}/copies`, name, {
                headers: {

                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'

                }}).
                then(response => {

                    let copyId = response.data.data.id
                    this.copied = true;

                    this.storeDataInStorage('copiedPageData', {orderNumber: this.orderNumber, orderName: this.orderName});

                    if(this.$parent.$parent.grantPermission(['ROLE_CENTRAL', 'ROLE_LOCAL', 'ROLE_EDITOR'])){

                        this.$router.push(`/order/${copyId}/copy`)
                        return;

                    }

                    this.$router.push(`/order/${copyId}/accept`)

                })
                .catch(error => {

                    console.error(error.response);
                    this.clearStorage('copiedPageData');

                })
                
            }

        },

    },

}
</script>

<style lang="scss" scoped>

.copy-popup-background{
    display:flex;
    justify-content: center;
    align-items: center;
    position: fixed;
    width:100%;
    height:100%;
    top:0;
    left:0;
    z-index: 200;
}

.copy-popup{
  background:#fff;
  border: 1px #d3020c solid;
  width: 400px;

  &__body{
    padding:30px;
    position:relative;
    display:flex;
    flex-direction: column;

    & h1{
        font-size: 14px;
    }

    & label{
        font-size: 9px;
        margin-bottom:5px;
    }

     & .form-group{
         width:50%;
     }

    & .form-group > input{
        font-size: 14px;
        color:#000000;
        opacity:1;
        font-weight: 400;
    }

    & p{
        font-size: 12px;
        color:#E3000B;
    }

  }

  &__footer{
      width:100%;
      display:flex;
      flex-direction: column;

      & button{
          margin-bottom: 15px;
          height:56px;
      }
  }
}

</style>
